import Model from '@/models/Model.js';

export default class Prerequisite extends Model {
    static entity = 'prerequisites';

    static modelName = 'Prerequisite';

    static fields() {
        return {
            id: this.attr(null),
            course_itemable_id: this.attr(null),
            course_itemable_type: this.attr(null),
            type: this.attr(null),

            ...super.fields(),

            course_itemable: this.morphTo('course_itemable_id', 'course_itemable_type_entity'),
        };
    }
}
